import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Typography,
  Tag,
  Button,
  Switch,
  Input,
  Divider,
} from 'antd';

import {
  createColumns,
  formatCell,
  sorter
} from '../../../helpers';

import DataTable from '../../DataTable';
import {
  Spinner,
  Dialog,
} from '../../UI';

import styles from './Search.module.css';

const { Title } = Typography;
const { TextArea } = Input;

class Search extends PureComponent {
  state = {
    show: false,
    info: false,
    user_desc: '',
    aff: '',
    modalContent: {},
  };

  componentDidMount () {
    this.props.fetchUserInfo(() => {
      this.props.fetchPushFeeds();
    });
  };

  open = (event, modal) => {
    const modalId = modal;
    const { rowid } = event.target.dataset;
    const index =  this.props.pushFeeds.data.length > 0 && this.props.pushFeeds.data.findIndex(el => el.rowId === parseInt(rowid));
    const { aff, user_desc } = this.props.pushFeeds.data[index];

    this.setState({
      aff: aff ? aff : '',
      user_desc: user_desc ? user_desc : '',
      [modalId]: !!modalId,
    });

    this.feedInfo(
      this.props.pushFeeds.data[index].aff,
      () => this.setState({ modalContent:  this.props.feedInfo[0] })
    );
  };

  close = (event, cb) => {
    this.setState({
      show: false,
      info: false,
      modalContent: {},
    });

    if (cb) {
      this.props.fetchPushFeeds();
    }
  };

  handleChange = (event) => {
    const { value } = event.target;

    this.setState({
      user_desc: value
    });
  };

  handleEdit = () => {
    const payload = {
      aff: this.state.aff,
      description: this.state.user_desc,
    };

    this.props.setFeedDesc(
      payload,
      (event) => this.close(event, true)
    );
  };

  handleSwitch = (value, rowId) => {
    const index =  this.props.pushFeeds.data.length > 0 && this.props.pushFeeds.data.findIndex(el => el.rowId === parseInt(rowId));
    const { aff } = this.props.pushFeeds.data[index];

    const payload = {
      aff,
      paused: value ? 1 : 0,
    };

    this.props.setFeedPaused(
      payload,
      () => this.props.fetchPushFeeds()
    );
  };

  feedInfo = (aff, cb) => {
    const payload = {
      aff
    };
    this.props.fetchFeedInfo(payload, cb);
  };

  render() {
    const {
      pageLoading,
      loading,
      pushFeeds,
      pushFeeds: {
        fields,
        tableName,
      }
    } = this.props;
    const {
      modalContent,
      user_desc,
      show,
      info,
    } = this.state;
    const fieldsObj = fields && fields[0];

    const renderTableCell = (text, record, item) => {
      const answer = (text === '1') ? 'YES' : 'NO';
      const {
        rowId,
        is_paused
      } = record;
      const {
        isLabel,
        button,
      } = item;

      let content = text;
      if (isLabel) {
        content = <Tag color={text === '1' ? '#87d068' : '#f50'}>{answer}</Tag>;
      } else if (button !== undefined) {
        if (button.type === 'switch') {
          content = (
            <div className={styles.switch}>
              <Switch
                defaultChecked={is_paused !== '0'}
                data-rowid={rowId}
                onClick={(value) => this.handleSwitch(value, rowId)}
              />
            </div>
          );
        }

        if (button.type === 'link') {
          content = item.button.action === 'edit' ? (
            <div className={styles.description}>
              <span>{text}</span>
              <Button
                type="link"
                className={styles['edit-btn']}
                data-rowid={rowId}
                onClick={(event) => this.open(event, 'show')}
              >
                Edit
              </Button>
            </div>
          ) : (
            <div className={styles.info}>
              <span>{text}</span>
              <Button
                type="link"
                className={styles['edit-btn']}
                data-rowid={rowId}
                onClick={(event) => this.open(event, 'info')}
              >Info</Button>
            </div>
          )
        }
      }

      return formatCell(item, content);
    };

    const columns = createColumns(
      fieldsObj,
      sorter,
      renderTableCell,
    );

    let content = <Spinner />;
    if (!pageLoading) {
      content = (
        <>
          <Divider />
          <DataTable
            loading={loading}
            table={{
              columns: columns,
              data: pushFeeds,
              tableName: tableName,
              toolbar: {
                titleExport: 'Search Export',
              }
            }}
          />
        </>
      );
    }

    const description = (
      <TextArea
        rows={3}
        value={user_desc}
        name="user_desc"
        onChange={this.handleChange}
      />
    );

    const {
      xmlURL,
      jsURL,
      directURL,
      statURL,
      StatExample,
      StatXMLParams,
      ReqXMLParams,
      RequestExample,
    } = modalContent;

    const feedInfo = (
      <div className={styles.feedInfo}>
        {!!modalContent && xmlURL ? (
          <>
            <div className={styles.feedInfoRow}>
              <strong>XML URL:</strong>
              <span>{xmlURL}</span>
            </div>
            {directURL &&<div className={styles.feedInfoRow}>
              <strong>Direct URL:</strong>
              <span>{directURL}</span>
            </div>}
            {jsURL && <div className={styles.feedInfoRow}>
              <strong>JS URL:</strong>
              <span>{jsURL}</span>
            </div>}
            <div className={styles.feedInfoRow}>
              <strong>Request Parameters:</strong>
              <span><pre>{ReqXMLParams}</pre></span>
            </div>
            <div className={styles.feedInfoRow}>
              <strong>Request Example:</strong>
              <span>
                <a href={RequestExample} target="_blank" rel="noopener noreferrer">{RequestExample}</a>
              </span>
            </div>
            <div className={styles.feedInfoRow}>
              <strong>Statistics URL:</strong>
              <span>{statURL}</span>
            </div>
            <div className={styles.feedInfoRow}>
              <strong>XML Statistics Parameters:</strong>
              <span><pre>{StatXMLParams}</pre></span>
            </div>
            <div className={styles.feedInfoRow}>
              <strong>Statistics Example:</strong>
              <span>
                 <a href={StatExample} target="_blank" rel="noopener noreferrer">{StatExample}</a>
              </span>
            </div>
          </>
        ) : (
          <Spinner size="small" />
        )}
      </div>
    );

    return (
      <div>
        <Title>Search</Title>
        {content}

        <Dialog
          title="Edit Description"
          visible={show}
          onOk={this.handleEdit}
          onCancel={(event) => this.close(event, true)}
          handleChange={this.handleChange}
          content={description}
        />

        <Dialog
          title="Feed Info"
          visible={info}
          onOk={this.close}
          onCancel={this.close}
          content={feedInfo}
          width={1170}
          hideCancel
        />
      </div>
    );
  }
}

Search.propTypes = {
  pageLoading: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  pushFeeds: PropTypes.object.isRequired,
  fetchUserInfo: PropTypes.func.isRequired,
  fetchPushFeeds: PropTypes.func.isRequired,
  setFeedDesc: PropTypes.func.isRequired,
  setFeedPaused: PropTypes.func.isRequired,
};

export default Search;
